import { colors, Icons } from 'bold-ui'
import { EstrategiaVacinacaoSelectFieldModel } from 'components/form/field/select/EstrategiaVacinacaoSelectField'
import { GrupoAtendimentoSelectFieldModel } from 'components/form/field/select/GrupoAtendimentoSelectField'
import { LocalAplicacaoSelectFieldModel } from 'components/form/field/select/LocalAplicacaoSelectField'
import { LoteImunobiologicoSelectModel } from 'components/form/field/select/LoteImunobiologicoSelectField/LoteImunobiologicoSelectField'
import { ViaAdministracaoVacinaSelectModel } from 'components/form/field/select/ViaAdministracaoVacinaSelectField'
import { metaPath } from 'util/metaPath'
import { LoteImunobiologicoFabricanteSelectFieldModel } from 'view/lote-imunobiologico/insert/LoteImunobiologicoFabricanteSelectField'

import { DoseItemProps } from '../detail/components/vacinacao/DoseItem'
import { DesfechoFormModel } from '../detail/soap/desfecho'

export interface AtendimentoVacinacaoState {
  condicoesVacinacao: CondicoesFormModel
  desfechoVacinacao: DesfechoFormModel
  registroVacinacao: RegistroVacinacaoFormModel[]
  imprimirAtendimento?: boolean
}

export interface CondicoesFormModel {
  gestante: boolean
  puerpera: boolean
  viajante: boolean
  comunicanteHanseniase: boolean
}

export interface RegistroVacinacaoFormModel {
  id: ID
  vacinacao: string
  tipoRegistroVacinacao: TipoRegistroDoseEnum
  isRegistroAnterior?: boolean
  imunobiologico: string
  estrategiaVacinacao: EstrategiaVacinacaoSelectFieldModel
  grupoAtendimento?: GrupoAtendimentoSelectFieldModel
  doseImunobiologico: string
  dataAprazamento: LocalDate
  dataAplicacao: LocalDate
  dataRegistro: LocalDate
  lote: string
  loteFabricante: string
  loteDataValidade: LocalDate
  loteImunobiologico: LoteImunobiologicoSelectModel
  viaAdministracao: ViaAdministracaoVacinaSelectModel
  localAplicacaoVacinacao: LocalAplicacaoSelectFieldModel
  observacoes: string
  fabricante: LoteImunobiologicoFabricanteSelectFieldModel
}

export const meta = metaPath<AtendimentoVacinacaoState>()

export interface ImunobiologicoRowModel {
  imunobiologicoId: ID
  nome: string
  doses: DoseItemProps[]
  ordem: number
}

export interface DoseItemModel {
  calendarioId: ID
  imunobiologicoId: ID
  doseId: ID
  status: StatusDoseEnum
  nome: string
  faixaEtaria: string
  dataAprazamento?: string
  registradoAtendimento?: boolean
  mostrarNoCalendarioDoGrupo: boolean
  nomeImuno: string
  nomeCompletoImuno: string
  siglaImuno: string
  prontuarioId: ID
}

export interface VacinasAplicadas {
  imunobiologicoId?: string
  imunobiologicoSigla?: string
  imunobiologicoNome?: string
  imunobiologicoNomeFiltro?: string
  doseId?: string
  doseNomeApresentacao?: string
  doseNome?: string
  doseSigla?: string
  dataAprazamento?: any
  dataRegistroAprazamento?: any
}
export enum TipoRegistroDoseEnum {
  APRAZAMENTO,
  APLICACAO,
  REGISTRO_ANTERIOR,
}
export enum StatusDoseEnum {
  APLICADA,
  DISPONIVEL,
  ATRASADA,
  FUTURA,
}

interface StatusProps {
  nome: string
  icon?: Icons
  fontColor: string
  iconColor?: string
  backgroundColor: string
  borderColor: string
}

export const statusDoseRecord: Record<StatusDoseEnum, StatusProps> = {
  [StatusDoseEnum.APLICADA]: {
    nome: 'Aplicada',
    icon: 'checkCircleFilled',
    fontColor: colors.green.c40,
    iconColor: colors.green.c40,
    backgroundColor: colors.green.c90,
    borderColor: colors.green.c60,
  },
  [StatusDoseEnum.DISPONIVEL]: {
    nome: 'Disponível',
    fontColor: colors.gray.c10,
    backgroundColor: colors.gray.c100,
    borderColor: colors.gray.c60,
  },
  [StatusDoseEnum.ATRASADA]: {
    nome: 'Atrasada',
    icon: 'timesFilled',
    fontColor: colors.red.c40,
    iconColor: colors.red.c40,
    backgroundColor: colors.red.c90,
    borderColor: colors.red.c60,
  },
  [StatusDoseEnum.FUTURA]: {
    nome: 'Futura',
    icon: 'clockFilled',
    fontColor: colors.gray.c10,
    iconColor: colors.blue.c40,
    backgroundColor: colors.gray.c100,
    borderColor: colors.gray.c60,
  },
}
